import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DigiLockerCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const payload = {
      status: params.get("status"),
      pageNo: params.get("pageNo"),
      succeeded: params.get("succeeded"),
      errorMessage: params.get("errorMessage"),
      docCode: params.get("docCode"), // if backend sends it
    };

    console.log("Sending to parent:", payload);

    if (window.opener) {
      window.opener.postMessage(
        {
          type: "DIGILOCKER_CALLBACK",
          payload,
        },
        window.location.origin,
      );

      window.close();
    }
  }, [location]);

  return <h3>Processing DigiLocker response...</h3>;
};

export default DigiLockerCallback;
